// dashboard-model.js

import { Model } from 'backbone';

class ReportDetailsModel extends Model {

    initialize() {
       
    }

    defaults() {
        return {};
    }


    parse(response, options)  {
        return response;
    }
}

export default ReportDetailsModel;
